// utils/storageUtils.ts

// export const getCompanyId = (): number | null | string => {
//   const raw = localStorage.getItem("user-info");
//   if (!raw) return null;

//   const parsed = JSON.parse(raw);
//   const userInfo = JSON.parse(parsed.userInfo);
//   return userInfo.companyId;
// };


export const getCompanyId = (): number | null => {
    const raw = localStorage.getItem("user-info");
    if (!raw) return null;

    try {
        const parsed = JSON.parse(raw);

        const userInfo =
            typeof parsed.userInfo === "string"
                ? JSON.parse(parsed.userInfo)
                : parsed.userInfo;

        return userInfo?.companyId ?? null;
    } catch (err) {
        console.error("Error parsing user-info:", err);
        return null;
    }
};